import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-ardis-green-dark text-white/80" data-id="element-215" data-mp="3ggtz0kj4bn6a">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-216" data-mp="32oni2w855c5s">
        <div data-id="element-217" data-mp="36qhdoq3hbpz3">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/ee6b71ba-e15b-42d0-ba5e-6294da9250ca.jpg" alt="LE PIAN DISTRIBUTION" className="h-14 w-auto rounded-md bg-white p-1.5" data-id="element-218" data-mp="36pza18ehm9h5" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed" data-id="element-219" data-mp="3lec768pb9yd8">
            Votre partenaire en approvisionnement. Le choix, la qualité, au meilleur prix.
          </p>
        </div>

        <div data-id="element-220" data-mp="3qf9q4ni5awfs">
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-221" data-mp="29z6woiixuvj2">Catégories</h4>
          <ul className="mt-4 space-y-2.5 text-sm" data-id="element-222" data-mp="2eyt6ehzk5tn4">
            {['Alimentation', 'Boisson', 'Maison et Décoration', 'Electronique'].map(c => <li key={c} data-id="element-223" data-mp="3l9sjf6xt4wpj">
                <a href="#categories" className="transition-colors hover:text-ardis-yellow" data-id="element-224" data-mp="3gagyrmubl72o">{c}</a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-225" data-mp="3v9b11gq8w6ef">
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-226" data-mp="3v91a9qxdlv7o">Liens</h4>
          <ul className="mt-4 space-y-2.5 text-sm" data-id="element-227" data-mp="3qaq17iewnoqi">
            {['Accueil', 'À propos de Nous', 'Nos produits', 'Nous contacter'].map(c => <li key={c} data-id="element-228" data-mp="34patc8mu2kd">
                <a href="#" className="transition-colors hover:text-ardis-yellow" data-id="element-229" data-mp="33e71cf6sut9">{c}</a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-230" data-mp="cu0fmmohkl2g">
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-231" data-mp="ct783jhpdrj9">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-232" data-mp="qsqfub6lr0v1">
            <li className="flex items-start gap-2.5" data-id="element-233" data-mp="qrf67uqh6yw0">
              <MapPinIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-234" data-mp="msxzvdevpsfn" />
              <span data-id="element-235" data-mp="tvw6kdlnj9ee">473 ROUTE DE PAUILLAC<br data-id="element-236" data-mp="two2xqn2pb5q" />33290 LE PIAN-MÉDOC</span>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-237" data-mp="yto87zc3m9vs">
              <PhoneIcon className="h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-238" data-mp="ys3egbxlyuyz" />
              <a href="tel:+33123152784" className="transition-colors hover:text-ardis-yellow" data-id="element-239" data-mp="13rproldfsb7s">+33 1 23 15 27 84</a>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-240" data-mp="18lu0zba6cvc1">
              <MailIcon className="h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-241" data-mp="1ckt18ikyo3x5" />
              <a href="mailto:contact@lepiandistribution.com" className="transition-colors hover:text-ardis-yellow" data-id="element-242" data-mp="1hk5vvpi2qfaa">contact@lepiandistribution.com</a>
            </li>
          </ul>
          <div className="mt-5 flex gap-3" data-id="element-243" data-mp="1rilf76av0k98">
            <a href="#" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-ardis-yellow hover:text-ardis-green-dark" data-id="element-244" data-mp="1rhk5p69hs5tm">
              <FacebookIcon className="h-4 w-4" data-id="element-245" data-mp="3tb18nwmogii1" />
            </a>
            <a href="#" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-ardis-yellow hover:text-ardis-green-dark" data-id="element-246" data-mp="2aevgo0iq629h">
              <InstagramIcon className="h-4 w-4" data-id="element-247" data-mp="21mk0r8l8lx7r" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50" data-id="element-248" data-mp="1wo8rayyutoq2">
        © {new Date().getFullYear()} LE PIAN DISTRIBUTION. Tous droits réservés.
      </div>
    </footer>;
}